import {
  FDAccordion,
  FDAccordionDetails,
  FDAccordionGroup,
  FDAccordionTitle, FDLozenge,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { dataAttrs } from 'Helpers/Testing';
import {
  TaxStrategyItem,
} from './TaxStrategyItem';

export const TaxStrategyTopWaysToSaveAccordionGroup = ({
  resource,
}) => {
  const [expanded, setExpanded] = React.useState(true);
  const groupHasItemWithNote = resource.attr('topWaysToSaveItems').resources().list().some(item => item.isTruthy('hasNote'));

  return (
    <FDAccordionGroup variant={'separated'} {...dataAttrs('tax-strategy-accordion-group')}>
      <FDAccordion
        {...dataAttrs('top-ways-to-save-accordion')}
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
      >
        <FDAccordionTitle>
          <FDStack direction={'row'} width={'100%'} justifyContent={'space-between'} alignItems={'center'}>
            <FDTitleText value={resource.attr('topWaysToSaveName')} size={'lg'} />
            {groupHasItemWithNote && (
              <FDLozenge
                label={'Notes'}
                color={'info'}
                size={'lg'}
                {...dataAttrs('tax-strategy-group-note-lozenge')}
              />
            )}
          </FDStack>
        </FDAccordionTitle>
        <FDAccordionDetails>
          <FDStack direction={'column'}>
            {
              resource.attr('topWaysToSaveItems').resources().list().map(item => (
                <TaxStrategyItem itemResource={item} key={item.id()} />
              ))
            }
          </FDStack>
        </FDAccordionDetails>
      </FDAccordion>
    </FDAccordionGroup>
  );
};

TaxStrategyTopWaysToSaveAccordionGroup.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
